import { parse as dateFnsParse } from 'date-fns'
import en from 'date-fns/locale/en-US'
import es from 'date-fns/locale/es'
import fr from 'date-fns/locale/fr'
import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'

type SupportedLocales = 'en' | 'es' | 'fr'
type DateFunctions = 'parseDateLocal'

const locales = {
  en,
  es,
  fr,
}

export default function useDateParsers(): Record<
  DateFunctions,
  (date: string) => Date
> {
  const { locale } = useIntl()

  const parse = useCallback(
    (date: string, format: string): Date =>
      dateFnsParse(date, format, new Date(), {
        locale: locales[locale as SupportedLocales] || locales.en,
      }),
    [locale],
  )

  return useMemo(
    () => ({
      parseDateLocal: (date: string) => parse(date, 'PP'),
    }),
    [parse],
  )
}
